import { render, staticRenderFns } from "./TabsView.vue?vue&type=template&id=414716be&scoped=true&"
import script from "./TabsView.vue?vue&type=script&lang=js&"
export * from "./TabsView.vue?vue&type=script&lang=js&"
import style0 from "./TabsView.vue?vue&type=style&index=0&id=414716be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414716be",
  null
  
)

export default component.exports